import React, { useEffect } from 'react';

const CSPProvider = ({ children }) => {
  useEffect(() => {
    // Create CSP meta tag
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Security-Policy';
    meta.content = `
      default-src 'self';
      script-src 'self' 'unsafe-inline' 'unsafe-eval' https://apis.google.com https://connect.facebook.net https://js.stripe.com;
      style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
      img-src 'self' data: https:;
      font-src 'self' https://fonts.gstatic.com;
      connect-src 'self' ${process.env.REACT_APP_API_BASE_URL} https://apis.google.com https://graph.facebook.com https://api.stripe.com;
      frame-src 'self' https://accounts.google.com https://www.facebook.com https://js.stripe.com https://hooks.stripe.com;
      object-src 'none';
      base-uri 'self';
      form-action 'self';
      upgrade-insecure-requests;
    `.replace(/\s+/g, ' ').trim();

    // Add CSP meta tag to document head
    document.head.appendChild(meta);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return children;
};

export default CSPProvider; 